import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { ClientCreditsService } from 'src/app/services/apiclient/clientcredits/clientcredits.service';

declare var paypal:any;
@Component({
  selector: 'app-confirm-credits',
  templateUrl: './confirm-credits.component.html',
  styleUrls: ['./confirm-credits.component.css']
})
export class ConfirmCreditsComponent implements OnInit {
  @ViewChild('paypal') paypalElement: ElementRef|any;

  @Input('credit_pay_intent') credit_pay_intent: any
  @Output() paypalEvent = new EventEmitter<any>();

  currCard$ = [];
  loader: boolean|any;
  errorMessage: string|any;

  constructor(
    private ClientCreditsService: ClientCreditsService
  ) { }

  ngOnInit() {
  }


  ngOnChanges(changes: SimpleChanges|any): void {
 

    if (changes.credit_pay_intent) {
   
     

      this.credit_pay_intent = changes.credit_pay_intent.currentValue;

      //evite les doublons d eboutons
      let previousValue=changes.credit_pay_intent.previousValue;
      let isEqual = _.isEqual(this.credit_pay_intent, previousValue);


      if (this.credit_pay_intent && this.credit_pay_intent.amount && this.credit_pay_intent.amount > 0 && !isEqual) {
              this.initPay();

      }
    }
  }

  /**
   * @description Crée une commande paypal
   * @returns {void}
   */
  createOrderPaypal(): Promise<any> {

    const that = this;

    that.loader = true;

    return new Promise((resolve, reject) => {

      that.ClientCreditsService.creditCard(this.credit_pay_intent, this.currCard$).then(data => {
     

        if (data.code === -3) {

          resolve(data.paypal_order);

        } else {

          that.errorMessage = data.message;
          that.loader = false;
          reject();

        }
      });

    });
  }


  /**
   * @description Initialise et configure stripe
   * @returns {void}
  */
  initPaypal(): void {

    const that = this;
    if (paypal) {
    
      paypal.Buttons(
        {
          commit: true,
          style: {
            height: 40,
            layout: 'horizontal',
            tagline: false,
            size: 'responsive',
            shape: 'rect',
            color: 'blue',
            label: 'checkout'   // label: 'pay',checkout pay paypal

          },

          createOrder: function (data:any, actions:any) {
            return that.createOrderPaypal().then(data => {
              return data;
            }).then(orderData => {
              return orderData.id
            })
          },
          onApprove: function (data:any, actions:any) {
            that.paypalEvent.emit(data.orderID);
          },

          onClick: () => {
            // Voir termes
          },

          onCancel: function (data:any, actions:any) {
            that.loader = false;
            // Show a cancel page or return to cart
          }

        }
      ).render(this.paypalElement.nativeElement);
    }
    else {
      // probleme init payPAl
      this.initPay("time");
    }
  }


  initPay(time?: any) {
    let timer = time ? 0 : 250;
    setTimeout(() => {
      this.initPaypal();
    }, timer);
  }
}


